import { render, staticRenderFns } from "./KitTypeModal.vue?vue&type=template&id=34d006de&scoped=true&"
import script from "./KitTypeModal.vue?vue&type=script&lang=js&"
export * from "./KitTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d006de",
  null
  
)

export default component.exports